import { render, staticRenderFns } from "./BlackoutPeriodAdd.vue?vue&type=template&id=6dc6d32a&scoped=true&"
import script from "./BlackoutPeriodAdd.vue?vue&type=script&lang=js&"
export * from "./BlackoutPeriodAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc6d32a",
  null
  
)

export default component.exports